<template>
  <div :class="{ 'hide-nav-cta': hideNavCTA }">
    <navigation landingpage fancy :utm="utm" />

    <section id="constuction-webinar-landingpage" class="hero">
      <div class="hero-body">
        <div class="container mt-6">
          <div class="mt-5 columns is-vcentered is-align-items-center">
            <div class="column is-8-desktop is-7-widescreen is-6-fullhd">
              <h1 class="title is-size-3-mobile is-size-2 has-text-white-ter mb-2">
                {{$t('views.construction-webinar.headline')}}
              </h1>

              <h3
                class="has-text-grey-lighter is-size-5 highlight-strong mb-5"
                style="text-wrap: pretty;"
                v-html="$t('views.construction-webinar.subline')"
              />

              <a
                v-if="$root.$i18n.locale === 'de'"
                href="https://airtable.com/app6wLZFQV5c8KrGS/pagX3SFVLYmOm0MZT/form"
                class="button is-medium is-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{$t('views.construction-webinar.hero-cta')}}
              </a>
              <button
                v-else
                disabled
                class="button is-medium"
                style="white-space: normal; height: unset"
              >
                {{$t('views.construction-webinar.not-available')}}
              </button>
            </div>

            <div class="column is-hidden-touch is-5-fullhd is-offset-1-fullhd">
              <figure class="image">
                <img
                  :alt="$t('views.service.hero.mood-alt')"
                  src="../../assets/mockup/laptop-construction-machines-DE.png"
                />
              </figure>
            </div>
          </div>
        </div>
      </div>

      <a href="#signup" class="has-text-white has-text-centered py-5">
        <fa icon="angle-double-down" class="fa-2x" />
      </a>
    </section>

    <section class="section is-medium is-clipped" id="signup">
      <div class="container">
          <div class="columns is-vcentered is-align-items-center">
            <div class="column is-5-tablet is-half is-half-widescreen">
              <h5 class="title is-5 mt-0" style="text-wrap: pretty;">
                {{$t('views.construction-webinar.pitch-headline')}}
              </h5>
              <p class="has-text-dark">
                {{$t('views.construction-webinar.pitch-description')}}
              </p>
            </div>

            <div class="column is-relative has-absolute-marquee-background is-7-tablet is-6-desktop is-offset-1-desktop is-5-widescreen">
              <div class="card">
                <div class="card-content">
                  <div class="level is-align-items-start-mobile is-mobile is-flex-direction-col-mobile has-gap-y-4">
                    <div class="has-text-centered has-gap-2 is-flex-direction-row-mobile is-flex is-flex-direction-column is-align-items-center">
                      <fa icon="clock" class="fa-lg fa-fw" />
                      <p>{{$t('views.construction-webinar.info-duration')}}</p>
                    </div>
                    <div class="has-text-centered has-gap-2 is-flex-direction-row-mobile is-flex is-flex-direction-column is-align-items-center">
                      <fa icon="laptop" class="fa-lg fa-fw" />
                      <p>{{$t('views.construction-webinar.info-location')}}</p>
                    </div>
                    <div class="has-text-centered has-gap-2 is-flex-direction-row-mobile is-flex is-flex-direction-column is-align-items-center">
                      <fa icon="euro-sign" class="fa-lg fa-fw" />
                      <p>{{$t('views.construction-webinar.info-price')}}</p>
                    </div>
                  </div>

                  <a
                    v-if="$root.$i18n.locale === 'de'"
                    href="https://airtable.com/app6wLZFQV5c8KrGS/pagX3SFVLYmOm0MZT/form"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="button is-primary is-medium is-fullwidth"
                  >
                    {{$t('views.construction-webinar.signup-now')}}
                  </a>
                  <button
                    v-else
                    disabled
                    class="button is-fullwidth is-medium"
                    style="white-space: normal; height: unset"
                  >
                    {{$t('views.construction-webinar.not-available')}}
                  </button>
                </div>
              </div>
            </div>
          </div>
      </div>
    </section>

    <section class="section is-medium has-background-dark has-text-centered">
      <h1 class="title mt-0 mb-5 is-size-4-mobile is-size-3-tablet is-size-2-desktop has-text-white-ter mb-2">
        {{$t('views.construction-webinar.looking-forward')}}
      </h1>
      
      <a
        v-if="$root.$i18n.locale === 'de'"
        href="http://rep.guide"
        target="_blank"
        rel="noopener noreferrer"
        class="button is-primary is-medium is-hidden-desktop"
      >
        {{$t('views.construction-webinar.signup-now')}}
      </a>
      <a
        v-if="$root.$i18n.locale === 'de'" 
        href="https://airtable.com/app6wLZFQV5c8KrGS/pagX3SFVLYmOm0MZT/form"
        target="_blank"
        rel="noopener noreferrer"
        class="button is-primary is-large is-hidden-touch"
      >
        {{$t('views.construction-webinar.signup-now')}}
      </a>
      <button
        v-if="$root.$i18n.locale !== 'de'"
        disabled
        class="button is-medium"
        style="white-space: normal; height: unset"
      >
        {{$t('views.construction-webinar.not-available')}}
      </button>
    </section>

    <footerNavigation />
  </div>
</template>

<script>
import footerNavigation from "../../components/footerNavigation.vue";
import navigation from "../../components/navigation.vue";
import { store } from "../../store";

export default {
	name: "construction-webinar",
	props: {
		utm: Object,
	},
	components: {
		navigation,
		footerNavigation,
	},
	data: () => {
		return {
			hideNavCTA: true,
		};
	},
	computed: {
		selectedPartner() {
			return store.selectedPartner;
		},
		validMail() {
			// NOTE: https://emailregex.com/
			return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
				this.email,
			);
		},
		formValid() {
			return this.email.length && this.validMail;
		},
		manufacturer() {
			const adGroup =
				this.$router.currentRoute.query?.utm_content?.split("ad-group-")[1];
			return getManufacturer(adGroup);
		},
		keyword() {
			const adGroup =
				this.$router.currentRoute.query?.utm_content?.split("ad-group-")[1];
			return getKeyword(adGroup);
		},
	},
	methods: {
		getPrivacyLink() {
			const TLD = this.selectedPartner?.custom_tld || "eu";
			const ORIGIN = `https://repguide.${TLD}`;
			return `${ORIGIN}/${this.$route.params.locale}/privacy`;
		},
	},
	mounted() {
		this.hideNavCTA = window.scrollY < 750;
		window.addEventListener("scroll", () => {
			this.hideNavCTA = window.scrollY < 750;
		});
	},
};
</script>

<style>
#constuction-webinar-landingpage.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
    url("../../assets/repguide-background-construction.jpg") no-repeat center center
      fixed;
  background-size: cover;
}
.highlight-strong strong {
  color: #e94a10 !important;
}

@media (min-width: 769px) {
  .has-absolute-marquee-background::after {
    content: "";
    position: absolute;
    z-index: -1;
    top: -1000px;
    left: -2rem;
    right: -2rem;
    height: calc(100vh + 1000px);
    background: linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url("../../assets/machinefinder-construction-machines-repeatable.jpeg");
    background-repeat: repeat-y;
    background-position: top center;
    background-size: 100%;
    /* animation: scrollBackground 10s linear infinite; */
  }

  /* @keyframes scrollBackground {
    from {
      background-position-y: 0;
    }
    to {
      background-position-y: 640px;
    }
  } */
}


.has-gap-2 {
  gap: 0.5rem;
}

.has-gap-y-4 {
  gap: 1rem 0;
}

@media (max-width: 500px) {
  .is-flex-direction-row-mobile {
    flex-direction: row !important;
  }
  .is-flex-direction-col-mobile {
    flex-direction: column !important;
  }
  .is-align-items-start-mobile {
    align-items: flex-start !important;
  }
}
</style>
